import { useState } from "react";
import { useAppSelector } from "../../store/Hooks";
import { FrontPageArticle, FrontPageData } from "../../store/viewmodels/FrontPageViewModel";
import { getFileElement } from "../../utils/TaskContentServices";

function FrontPageArticlesMain(): JSX.Element {
    const frontPageData: FrontPageData = useAppSelector(state => state.frontPageData);
    let articles = Array.from(frontPageData.frontPageArticles);
    articles = articles.sort(function (a, b) { return a.index - b.index })

    const [articleIndex, setArticleIndex] = useState(0);
    const maxIndex = articles.length - 1;

    const handleNextArticle = (index: number) => {
        let nextIndex = articleIndex + index;
        if (nextIndex < 0) setArticleIndex(maxIndex);
        else if (nextIndex > maxIndex) setArticleIndex(0);
        else (setArticleIndex(nextIndex));
    }

    let content: JSX.Element = (
        <div className="w-full">
            <span>Lisätietoa VIKKE-hankkeesta: </span>
            <a href="https://vikke.nmi.fi/" target="_blank" rel="noopener noreferrer" className="font-bold text-teal-500">https://vikke.nmi.fi/</a>
        </div>);

    if (frontPageData?.frontPageArticles.length > 0) {
        const article: FrontPageArticle = articles[articleIndex];
        content = <FrontPageArticleItem article={article} articleIndex={articleIndex} handleNextArticle={handleNextArticle} maxIndex={maxIndex} />;
    }

    return (
        <div className="flex m-6">
            {content}
        </div>
    );
}


interface FrontPageArticleItemProps {
    article: FrontPageArticle
    articleIndex: number
    handleNextArticle: (index: number) => void,
    maxIndex: number
}

function FrontPageArticleItem(props: FrontPageArticleItemProps): JSX.Element {
    let currentArticle: number = props.articleIndex + 1;
    let articleCount: number = props.maxIndex + 1;

    let isFile: boolean = props.article.frontpage_files.length > 0 ? true : false;
    let isTextContent: boolean = props.article.content.length > 0 ? true : false;
    let show: boolean = articleCount > 1 ? true : false;

    let vid: JSX.Element = isFile ? getFileElement(props.article.frontpage_files[0]) : <></>;
    let textContentElement = isTextContent ? <div className={isFile ? "text-justify w-full max-h-full " : "w-full"}>{props.article.content}</div> : <></>;
    let fileContentElement = isFile ? <div className={isTextContent ? "flex justify-center mx-auto mt-0 mb-auto w-full max-h-full" : "flex justify-center mx-auto mt-0 mb-auto max-w-full "}>{vid}</div> : <></>;


    return (
        <div className="w-full ">
            <div className="flex pb-2 ">
                <h1 className="w-full text-3xl font-bold leading-tight text-teal-700">{props.article.title}</h1>
                <div className={show ? "text-right" : "hidden"}>
                    <span className="text-gray-400 text-xs">{currentArticle + "/" + articleCount}</span>
                    <div className="flex">
                        <button className="text-3xl border hover:bg-gray-100 text-gray-400 ri-arrow-left-s-fill" onClick={() => props.handleNextArticle(-1)}></button>
                        <button className="text-3xl border hover:bg-gray-100 text-gray-400 ri-arrow-right-s-fill" onClick={() => props.handleNextArticle(1)}></button>
                    </div>
                </div>
            </div>
            <div className="lg:py-2 lg:flex 4xl:text-lg">
                <div className="lg:max-w-1/3 mr-5">
                    {textContentElement}
                </div>
                <div className="flex lg:w-2/3 max-h-fit mt-5 lg:mt-0 justify-center mx-auto">
                    {fileContentElement}
                </div>
            </div>
        </div >);
}

export default FrontPageArticlesMain;